import * as yup from 'yup';
import { parseUnits } from 'utils/units';

yup.addMethod<yup.StringSchema>(
  yup.string,
  'bnMax',
  function bnMax(this, maxValue: string, decimals: number, message: string) {
    return this.test(function (value: string | undefined) {
      const { path, createError } = this;

      try {
        const bnValue = parseUnits(value ?? '', decimals);
        const bnMax = parseUnits(maxValue, decimals);

        if (bnValue.lte(bnMax)) {
          return true;
        }

        return createError({
          path,
          message: message,
          params: { max: maxValue },
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        return createError({ path, message: '${label} invalid value' });
      }
    });
  }
);

yup.addMethod<yup.StringSchema>(
  yup.string,
  'bnMin',
  function bnMin(this, minValue: string, decimals: number, message: string) {
    return this.test(function (value: string | undefined) {
      const { path, createError } = this;

      try {
        const bnValue = parseUnits(value ?? '', decimals);
        const bnMin = parseUnits(minValue, decimals);
        if (bnValue.gte(bnMin)) {
          return true;
        }

        if (bnValue.eq(0)) {
          return createError({ path, message: '${label} should not be zero' });
        }

        return createError({
          path,
          message: message,
          params: { min: minValue },
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        return createError({ path, message: '${label} invalid value' });
      }
    });
  }
);

yup.addMethod<yup.StringSchema>(
  yup.string,
  'bnMoreThan',
  function bnMoreThan(
    this,
    moreThanValue: string,
    decimals: number,
    message: string
  ) {
    return this.test(function (value: string | undefined) {
      const { path, createError } = this;

      try {
        const bnValue = parseUnits(value ?? '', decimals);
        const bnMoreThanValue = parseUnits(moreThanValue, decimals);
        if (bnValue.gt(bnMoreThanValue)) {
          return true;
        }

        return createError({
          path,
          message: message,
          params: { moreThan: value },
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        return createError({ path, message: '${label} invalid value' });
      }
    });
  }
);

export const tokenBaseValidation = yup
  .string()
  .matches(/^[0-9.]+$/, 'Must be only digits');
